/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Misha Kokoulin
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */

import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { requestSaga } from '@/main/sagas/requestSaga';
import { API_HOSTNAME } from '@modules/app/Api';

import { loadTableListAction, updateRowsStartFailure, updateRowsStartSuccessful } from '../actions/tableActions';
import type { IUpdateRowsStartPayload } from '../types/tableTypes';

export function* updateRowsSaga(action: { payload: IUpdateRowsStartPayload }): SagaIterator {
    yield call(requestSaga, API_HOSTNAME + action.payload.url, action.payload.method);
    try {
        yield put(updateRowsStartSuccessful());
        yield put(loadTableListAction({ force: true }));
    } catch (e: any) {
        yield put(updateRowsStartFailure(e));
    }
}
